import styled from '@emotion/styled';

import RegularText from '@zego/components/atoms/RegularText';

const BoldText = styled(RegularText)(
  {
    fontWeight: 700,
  },
  props => ({ color: props.color }),
);

export default BoldText;
